import ImageWithFallback from '@components/image/ImageWithFallback'
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid'

const TokenLogo = ({
  logoUrl,
  size = 'normal',
}: {
  logoUrl: string | undefined
  size?: 'small' | 'normal'
}) => {
  const imageSize = size === 'small' ? 16 : 24

  return logoUrl ? (
    <div
      className={`${
        size === 'small' ? 'size-[16px]' : 'size-[24px]'
      } relative flex shrink-0 items-center justify-center bg-th-bkg-2`}
    >
      <ImageWithFallback
        alt="Logo"
        width={imageSize}
        height={imageSize}
        src={logoUrl}
      />
    </div>
  ) : (
    <QuestionMarkCircleIcon
      className={`${
        size === 'small' ? 'size-[16px]' : 'size-[24px]'
      } text-th-fgd-3`}
    />
  )
}

export default TokenLogo
